import React, { useState, useEffect } from "react";
import "./Commision.css";
import { NewSideBarAdmin } from "../../NewSideBarAdmin";
import axios from "axios";

const API = process.env.REACT_APP_PHP_APP_URL;

/* ═══════════════════════════════════════════════════════
   SVG ICONS — Professional Feather-style
   ═══════════════════════════════════════════════════════ */
const Icons = {
  globe: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  store: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  link: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  edit: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  trash: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  warning: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  plus: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  save: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" />
    </svg>
  ),
  list: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
  ),
  inbox: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </svg>
  ),
  dollar: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  ),
  arrowRight: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
    </svg>
  ),
};

const typeIcon = (t: string) =>
  t === "global" ? Icons.globe : Icons.store;

const typeCls = (t: string) =>
  t === "global" ? "type-global" : "type-magasin";

/* ═══════════════════════════════════════════════════════ */

interface CommissionRule {
  id: number;
  source_magasin_id: number | null;
  target_magasin_id: number | null;
  commission_type: "global" | "magasin_all";
  commission_value: number;
  priority: number;
  created_at: string;
  source_magasin_name: string | null;
  target_magasin_name: string | null;
}

interface Magasin { IdMagasin: number; NomMagasin: string; }

const LABELS: Record<string, string> = {
  global: "Commission Globale",
  magasin_all: "Commission par Magasin",
};

/* ── Delete Modal ──────────────────────────────────────── */
const DeleteModal = ({
  rule, onConfirm, onCancel, busy,
}: { rule: CommissionRule; onConfirm: () => void; onCancel: () => void; busy: boolean }) => {
  const label =
    rule.commission_type === "global"
      ? "Commission globale"
      : `Commission pour ${rule.source_magasin_name}`;

  return (
    <div className="cm-overlay" onClick={onCancel}>
      <div className="cm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cm-modal-dot">{Icons.warning}</div>
        <h3>Supprimer cette commission ?</h3>
        <p>
          Cette action est irréversible. La règle sera définitivement
          supprimée et ne s'appliquera plus aux transactions.
        </p>
        <div className="cm-modal-info">
          <div className="lbl">Règle concernée</div>
          <div className="val">{typeIcon(rule.commission_type)} {label} — {rule.commission_value}%</div>
        </div>
        <div className="cm-modal-btns">
          <button className="cm-modal-btn cancel" onClick={onCancel} disabled={busy}>
            Annuler
          </button>
          <button className="cm-modal-btn danger" onClick={onConfirm} disabled={busy}>
            {busy ? (
              <><span className="cm-spinner" style={{ width: 14, height: 14, borderWidth: 2 }} /> Suppression…</>
            ) : (
              <>{Icons.trash} Supprimer</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════════════
   MAIN
   ═══════════════════════════════════════════════════════ */
const Commission: React.FC = () => {
  const [tab, setTab] = useState<"global" | "magasin_all">("global");
  const [rules, setRules] = useState<CommissionRule[]>([]);
  const [magasins, setMagasins] = useState<Magasin[]>([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState({ show: false, msg: "" });
  const [editId, setEditId] = useState<number | null>(null);
  const [delRule, setDelRule] = useState<CommissionRule | null>(null);
  const [delBusy, setDelBusy] = useState(false);

  const [val, setVal] = useState("");
  const [prio, setPrio] = useState("0");
  const [srcId, setSrcId] = useState("");

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const [c, m] = await Promise.all([
        axios.get(`${API}/admin/commission`),
        axios.get(`${API}/magasins`),
      ]);
      // Filter out any stale magasin_to_magasin rules in rules view to avoid React errors
      const safeRules = (c.data || []).filter((r: any) => r.commission_type !== 'magasin_to_magasin');
      setRules(safeRules);
      setMagasins(m.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const reset = () => { setVal(""); setPrio("0"); setSrcId(""); setEditId(null); };

  const flash = (msg: string) => {
    setToast({ show: true, msg });
    setTimeout(() => setToast({ show: false, msg: "" }), 2600);
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    const p: any = {
      commission_type: tab,
      commission_value: parseFloat(val),
      priority: parseInt(prio) || 0,
    };
    if (tab === "magasin_all") p.source_magasin_id = parseInt(srcId);
    try {
      if (editId) {
        p.id = editId;
        await axios.post(`${API}/admin/commission/update`, p);
        flash("Commission modifiée avec succès");
      } else {
        await axios.post(`${API}/admin/commission/create`, p);
        flash("Nouvelle commission créée");
      }
      reset(); await load();
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  const doDelete = async () => {
    if (!delRule) return;
    setDelBusy(true);
    try {
      await axios.delete(`${API}/admin/commission/${delRule.id}/delete`);
      flash("Commission supprimée");
      setDelRule(null); await load();
    } catch (e) { console.error(e); }
    finally { setDelBusy(false); }
  };

  const startEdit = (r: CommissionRule) => {
    setTab(r.commission_type);
    setVal(r.commission_value.toString());
    setPrio(r.priority.toString());
    setSrcId(r.source_magasin_id?.toString() || "");
    setEditId(r.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const filtered = rules.filter((r) => r.commission_type === tab);
  const gCnt = rules.filter((r) => r.commission_type === "global").length;
  const mCnt = rules.filter((r) => r.commission_type === "magasin_all").length;

  const ruleLabel = (r: CommissionRule) =>
    r.commission_type === "global"
      ? "Appliquée universellement par défaut"
      : `Entre ${r.source_magasin_name || "—"} et tous les autres magasins`;

  return (
    <>
      <div className="center-page">
        <NewSideBarAdmin />

        {loading ? (
          <div className="cm-loading">
            <div className="cm-spinner" />
            <span>Chargement des commissions…</span>
          </div>
        ) : (
          <div className="cm-page">
            {/* Toast */}
            {toast.show && (
              <div className="cm-toast">
                <div className="cm-toast-dot">{Icons.check}</div>
                <div>
                  <h4>Succès</h4>
                  <p>{toast.msg}</p>
                </div>
              </div>
            )}

            {/* Delete Modal */}
            {delRule && (
              <DeleteModal
                rule={delRule}
                onConfirm={doDelete}
                onCancel={() => setDelRule(null)}
                busy={delBusy}
              />
            )}

            {/* Header */}
            <div className="cm-header">
              <div className="cm-header-text">
                <h1>Gestion des Commissions</h1>
                <p>Définissez les taux de commission applicables. Les règles spécifiques par magasin prennent la priorité sur le taux global.</p>
              </div>
              <div className="cm-header-badge">
                {Icons.dollar} {rules.length} règle{rules.length !== 1 ? "s" : ""} active{rules.length !== 1 ? "s" : ""}
              </div>
            </div>

            {/* Stats */}
            <div className="cm-stats">
              <div className="cm-stat">
                <div className={`cm-stat-icon type-global`}>{Icons.globe}</div>
                <div>
                  <h4>{gCnt}</h4>
                  <span>Globales</span>
                </div>
              </div>
              <div className="cm-stat">
                <div className={`cm-stat-icon type-magasin`}>{Icons.store}</div>
                <div>
                  <h4>{mCnt}</h4>
                  <span>Par Magasin</span>
                </div>
              </div>
            </div>

            {/* Tabs */}
            <div className="cm-tabs">
              {(["global", "magasin_all"] as const).map((t) => (
                <button key={t} className={`cm-tab ${tab === t ? "active" : ""}`}
                  onClick={() => { setTab(t); reset(); }}>
                  {typeIcon(t)} {LABELS[t]}
                </button>
              ))}
            </div>

            {/* Grid */}
            <div className="cm-grid">
              {/* Form */}
              <div className="cm-form-card">
                <h3>
                  {editId ? Icons.edit : Icons.plus}
                  {editId ? "Modifier la règle" : "Nouvelle règle"}
                </h3>
                <p className="cm-form-sub">
                  {tab === "global" && "Taux de commission appliqué par défaut à toutes les transactions"}
                  {tab === "magasin_all" && "Taux de commission appliqué entre le magasin choisi et tous les autres"}
                </p>

                <form onSubmit={submit}>
                  {tab === "magasin_all" && (
                    <div className="cm-fg">
                      <label>Magasin</label>
                      <select value={srcId} onChange={(e) => setSrcId(e.target.value)} required>
                        <option value="">Sélectionner un magasin</option>
                        {magasins.map((m) => (
                          <option key={m.IdMagasin} value={m.IdMagasin}>{m.NomMagasin}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div className="cm-form-row">
                    <div className="cm-fg">
                      <label>Commission (%)</label>
                      <input type="number" step="0.01" min="0" max="100" placeholder="5.00"
                        value={val} onChange={(e) => setVal(e.target.value)} required />
                    </div>
                    <div className="cm-fg">
                      <label>Priorité</label>
                      <input type="number" min="0" placeholder="0"
                        value={prio} onChange={(e) => setPrio(e.target.value)} />
                    </div>
                  </div>

                  <button className="cm-btn-save" type="submit" disabled={saving}>
                    {saving ? "Enregistrement…" : editId ? <>{Icons.save} Mettre à jour</> : <>{Icons.save} Enregistrer</>}
                  </button>

                  {editId && (
                    <button type="button" className="cm-btn-cancel-form" onClick={reset}>
                      Annuler la modification
                    </button>
                  )}
                </form>
              </div>

              {/* Rules List */}
              <div className="cm-rules-card">
                <div className="cm-rules-top">
                  <h3>{Icons.list} Règles actives</h3>
                  <span className="cm-rules-badge">
                    {filtered.length} règle{filtered.length !== 1 ? "s" : ""}
                  </span>
                </div>

                {filtered.length === 0 ? (
                  <div className="cm-empty">
                    <div className="cm-empty-dot">{Icons.inbox}</div>
                    <h4>Aucune règle définie</h4>
                    <p>Créez votre première règle via le formulaire</p>
                  </div>
                ) : (
                  filtered.map((r) => (
                    <div className="cm-rule" key={r.id}>
                      <div className={`cm-rule-dot ${typeCls(r.commission_type)}`}>
                        {typeIcon(r.commission_type)}
                      </div>
                      <div className="cm-rule-info">
                        <div className="cm-rule-name">{ruleLabel(r)}</div>
                        <div className="cm-rule-meta">
                          <span>#{r.id}</span>
                          <span>Priorité {r.priority}</span>
                          <span>
                            {r.created_at
                              ? new Date(r.created_at).toLocaleDateString("fr-FR", {
                                  day: "2-digit", month: "short", year: "numeric",
                                })
                              : "—"}
                          </span>
                        </div>
                      </div>
                      <div className="cm-rule-pct">{r.commission_value}%</div>
                      <div className="cm-rule-btns">
                        <button className="cm-rule-btn" title="Modifier" onClick={() => startEdit(r)}>
                          {Icons.edit}
                        </button>
                        <button className="cm-rule-btn del" title="Supprimer" onClick={() => setDelRule(r)}>
                          {Icons.trash}
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Commission;
